module.exports = __webpack_public_path__ + "static/media/caterspot-bartender.05050864.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caterspot-bartender.jpg
// module id = 1643
// module chunks = 0